import e from "./index.ce.vue.js";
import { defineAndRegisterElement as t } from "../../utils/register-element.js";
const r = t(e);
export {
  r as initUserSelectedDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/userSelectedDialog/index.js
// module id = 1296
// module chunks = 41